/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateResourceObjectBorrowRequest,
  GetResourceObjectBorrowsParams,
  ResourceObjectBorrowDto,
  UpdateResourceObjectBorrowRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetResourceObjectBorrowsUrl = (params?: GetResourceObjectBorrowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectBorrow/GetResourceObjectBorrows?${stringifiedParams}` : `/api/ResourceObjectBorrow/GetResourceObjectBorrows`
}

export const getResourceObjectBorrows = async (params?: GetResourceObjectBorrowsParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectBorrowDto[]> => {

  return customInstance<ResourceObjectBorrowDto[]>(getGetResourceObjectBorrowsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceObjectBorrowsQueryKey = (params?: GetResourceObjectBorrowsParams,) => {
    return [
    `/api/ResourceObjectBorrow/GetResourceObjectBorrows`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceObjectBorrowsQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectBorrowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectBorrows>>> = ({ signal }) => getResourceObjectBorrows(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceObjectBorrowsQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectBorrows>>>
export type GetResourceObjectBorrowsQueryError = ErrorType<unknown>


export function useGetResourceObjectBorrows<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectBorrowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectBorrows>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectBorrows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectBorrows<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectBorrows>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectBorrows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectBorrows<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectBorrows<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectBorrowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectBorrowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectBorrowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectBorrows>>> = ({ signal }) => getResourceObjectBorrows(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceObjectBorrowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectBorrows>>>
export type GetResourceObjectBorrowsSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectBorrowsSuspense<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectBorrowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectBorrowsSuspense<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectBorrowsSuspense<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectBorrowsSuspense<TData = Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectBorrowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectBorrows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectBorrowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateResourceObjectBorrowUrl = () => {




  return `/api/ResourceObjectBorrow/CreateResourceObjectBorrow`
}

export const createResourceObjectBorrow = async (createResourceObjectBorrowRequest: CreateResourceObjectBorrowRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectBorrowDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectBorrowDto>(getCreateResourceObjectBorrowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createResourceObjectBorrowRequest)
  }
);}





export const getCreateResourceObjectBorrowMutationKey = () => ['createResourceObjectBorrow'] as const;

export const getCreateResourceObjectBorrowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectBorrow>>, TError,CreateResourceObjectBorrowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectBorrow>>, TError,CreateResourceObjectBorrowMutationVariables, TContext> => {

const mutationKey = getCreateResourceObjectBorrowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceObjectBorrow>>, CreateResourceObjectBorrowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResourceObjectBorrow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceObjectBorrowMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceObjectBorrow>>>
    export type CreateResourceObjectBorrowMutationBody = BodyType<CreateResourceObjectBorrowRequest>
    export type CreateResourceObjectBorrowMutationError = ErrorType<unknown>
    export type CreateResourceObjectBorrowMutationVariables = {data: BodyType<CreateResourceObjectBorrowRequest>}

    export const useCreateResourceObjectBorrow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectBorrow>>, TError,CreateResourceObjectBorrowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResourceObjectBorrow>>,
        TError,
        CreateResourceObjectBorrowMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceObjectBorrowMutationOptions(options), queryClient);
    }
    export const getUpdateResourceObjectBorrowUrl = () => {




  return `/api/ResourceObjectBorrow/UpdateResourceObjectBorrow`
}

export const updateResourceObjectBorrow = async (updateResourceObjectBorrowRequest: UpdateResourceObjectBorrowRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectBorrowDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectBorrowDto>(getUpdateResourceObjectBorrowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateResourceObjectBorrowRequest)
  }
);}





export const getUpdateResourceObjectBorrowMutationKey = () => ['updateResourceObjectBorrow'] as const;

export const getUpdateResourceObjectBorrowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectBorrow>>, TError,UpdateResourceObjectBorrowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectBorrow>>, TError,UpdateResourceObjectBorrowMutationVariables, TContext> => {

const mutationKey = getUpdateResourceObjectBorrowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResourceObjectBorrow>>, UpdateResourceObjectBorrowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateResourceObjectBorrow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceObjectBorrowMutationResult = NonNullable<Awaited<ReturnType<typeof updateResourceObjectBorrow>>>
    export type UpdateResourceObjectBorrowMutationBody = BodyType<UpdateResourceObjectBorrowRequest>
    export type UpdateResourceObjectBorrowMutationError = ErrorType<unknown>
    export type UpdateResourceObjectBorrowMutationVariables = {data: BodyType<UpdateResourceObjectBorrowRequest>}

    export const useUpdateResourceObjectBorrow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectBorrow>>, TError,UpdateResourceObjectBorrowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResourceObjectBorrow>>,
        TError,
        UpdateResourceObjectBorrowMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceObjectBorrowMutationOptions(options), queryClient);
    }
